module.exports = __webpack_public_path__ + "static/media/Sign in 1.a1b484ff.svg";